import type { Film } from "@/types/film";

interface DetailContentProps {
  film: Film;
}

export default function DetailContent({ film }: DetailContentProps) {
  const infoRows = [
    { label: "导演", value: film.director },
    { label: "主演", value: film.cast.join("、") },
    { label: "上映年份", value: `${film.year} 年` },
    { label: "制片地区", value: film.region },
    { label: "类型", value: film.genres.join(" / ") },
    { label: film.kind === "movie" ? "片长" : "集数", value: film.duration },
  ];

  return (
    <>
      <section className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-7">
        <h2 className="flex items-center gap-2 font-heading text-lg font-semibold text-foreground-950 md:text-xl">
          <span className="h-4 w-[3px] rounded-full bg-accent-500" />
          基本资料
        </h2>
        <dl className="mt-4 grid grid-cols-1 gap-x-8 gap-y-0 sm:grid-cols-2">
          {infoRows.map((row) => (
            <div
              key={row.label}
              className="flex gap-4 border-b border-background-100 py-2.5 last:border-b-0 sm:last:border-b"
            >
              <dt className="w-16 shrink-0 text-xs text-foreground-500">{row.label}</dt>
              <dd className="min-w-0 flex-1 text-xs leading-relaxed text-foreground-800">{row.value}</dd>
            </div>
          ))}
        </dl>
      </section>

      <section className="mt-6 rounded-lg border border-background-200 bg-background-50 p-5 md:p-7">
        <h2 className="flex items-center gap-2 font-heading text-lg font-semibold text-foreground-950 md:text-xl">
          <span className="h-4 w-[3px] rounded-full bg-accent-500" />
          剧情简介
        </h2>
        <div className="mt-4 space-y-4 text-sm leading-[1.95] text-foreground-700">
          {film.synopsis.map((paragraph, index) => (
            <p key={index} className={index === 0 ? "first-letter:float-left first-letter:mr-2 first-letter:font-heading first-letter:text-3xl first-letter:font-semibold first-letter:leading-[1.1] first-letter:text-primary-600" : ""}>
              {paragraph}
            </p>
          ))}
        </div>
        <p className="mt-5 rounded-md bg-background-100 px-4 py-3 text-[11px] leading-relaxed text-foreground-500">
          说明：以上剧情为演示文本，用于展示详情页的阅读排版。站内不提供视频播放服务。
        </p>
      </section>
    </>
  );
}